import React, {useEffect, useState, useMemo} from "react"
import { useParams, useNavigate } from "react-router-dom";

import CourseCard from "../components/cards/CourseCard"
import PageTitle from "../components/PageTitle"
import AddCard from "../components/cards/AddCard"
import CardTag from "../components/cards/CardTag"
import BreadcrumbsBase from "../components/buttons/Breadcrumbs"

import { wordNumDeclention } from "../utils";
import generateBreadcrumbs from "../utils/breadcrumbs";
import { $host } from "../../../http";

const TeachersCoursesSections = () => {
    const [sections, setSections] = useState([])
    const [breadcrumbs, setBreadcrumbs] = useState([])  

    const navigate = useNavigate()

    const sectionsCounted = useMemo(() => {
        if (sections) {
            return sections.map(s => {
                const count = s.questions_per_theme.reduce((prev, next) => {
                    prev += +next.question_count
                    return prev
                }, 0)
                s.questions_count = count
                return s
            })
        }
        return []
    }, [sections])
    

    const { id: courseId } = useParams()

    const fetchSections = async () => {
        try {
            const {data} = await $host.get(`/api/students/courses/paragraphs/${courseId}`)
            setSections(data.paragraphs)
            setBreadcrumbs(generateBreadcrumbs(data.breadcrumbs))
        } catch(e) {
            console.error(e)
        }
    }

    useEffect(() => {
        (async () => {
            try {
                fetchSections()
            } catch(e) {
                console.error(e)
            }
            
        })();
    }, [courseId])

    const onDeleteParagraph = async (paragraphId) => {
        try {
            await $host.delete(`/api/teachers/paragraphs/${paragraphId}`)
            await fetchSections()
        } catch(e) {
            console.error(e)
        }
    }

    const onEditParagraph = async (paragraphId) => {
        navigate(`/teachers-cabinet/section/${paragraphId}/edit`)
    }


    return (
        <section className="py-10 px-6 w-full">
            <BreadcrumbsBase items={breadcrumbs} />
            <PageTitle className="pb-8 pl-6 pt-16">Разделы</PageTitle>
            <div className="flex flex-wrap gap-2">
                <AddCard link={`add-section`} />
                {sections && sectionsCounted.map(s => (
                    <CourseCard
                        onDelete={()=>onDeleteParagraph(s.id)}
                        onEdit={()=>onEditParagraph(s.id)}
                        title={s.title} link={`/teachers-cabinet/section/${s.id}`} key={s.id}>
                        {
                            s.themes && <CardTag text={`${s.themes.length} ${wordNumDeclention(s.themes.length, 'paragraph')}`} />
                        }
                        {s.questions_count > 0 && <CardTag text={`${s.questions_count} дз`} theme="success" />}
                    </CourseCard>
                ))}
            </div>
        </section>
    )
}

export default TeachersCoursesSections